// ponytail: joins URL segments with a single slash, collapsing accidental
// doubles while preserving the protocol's `://`. Replaces a ~75-line vendored
// copy of the `url-join` package that only ever joined a base + path here.
const COLLAPSE_SLASHES = /([^:]\/)\/+/g;

export const urlJoin = (...parts: string[]): string =>
  parts.filter(Boolean).join('/').replace(COLLAPSE_SLASHES, '$1');
